import { onDOMReady, htmlElementExistsVerify, templateToHtml } from '../helpers';
import { init as initPageRmaSection } from "../sections/page-rma";

const DEBUG = false;

const onRmaSuccess = function () {
  document.getElementById('rma__order').style.display = 'none';
  document.getElementById('rma__rma').style.display = 'none';
  document.getElementById('rma__form').style.display = 'none';
  document.getElementById('rma__success').style.display = 'block';
}

export function init() {
  const is_rma_template = !!document.querySelector('[data-template-suffix="rma"]');

  if(!is_rma_template) return;
  initPageRmaSection();

  if (!window.RMA) return;

  const customerCare = 'customerservice@charlesjeffrey.net';
  const reasons = window.RMA.reasons;

  const replaceAllText = function (nodelist, newInnerText) {
    if (nodelist && nodelist.length) {
      var items = Array.from(nodelist)

      items.map(function (item) {
        item.innerText = newInnerText;
      })
    }
  }

  const toggleAll = function (nodelist, displayValue) {
    if (nodelist && nodelist.length) {
      var items = Array.from(nodelist);
      items.map(function (item) {
        item.style.display = displayValue;
      });
    }
  }

  const setAllNewValue = function (nodelist, newValue) {
    if (nodelist && nodelist.length) {
      var items = Array.from(nodelist);
      items.map(function (item) {
        item.value = newValue;
      });
    }
  }

  const appendAllEl = function (nodelist, elementToAppend) {
    if (nodelist && nodelist.length) {
      var items = Array.from(nodelist);
      items.map(function (item) {
        item.append(elementToAppend);
      });
    }
  }

  const setAttributeAll = function (nodelist, attrName, attrValue) {
    if (nodelist && nodelist.length) {
      var items = Array.from(nodelist);
      items.map(function (item) {
        item.setAttribute(attrName, attrValue);
      });
    }
  }


  onDOMReady(function () {
    const RMA_URL = 'https://dsintegtest.dianacorp.com/rma';
    const form = document.getElementById('rma__form');
    const expiry_days = form.getAttribute('data-expiry-days');
    const current_date = Date.parse(new Date());

    let orderNameEl;
    let orderName;
    let emailEl;
    let email;
    let shopInput = document.getElementById('rma__shop');
    let shop = shopInput.value;
    let tokenInput = document.getElementById('rma__token');
    let token = tokenInput.value;

    if (!htmlElementExistsVerify({ shop, token })) {
      return;
    };

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      orderNameEl = document.getElementById('rma__orderName');
      emailEl = document.getElementById('rma__email');

      if (!htmlElementExistsVerify({ orderNameEl, emailEl })) {
        return;
      };

      orderName = orderNameEl.value.toUpperCase();
      email = emailEl.value;

      let rmaOrder = document.getElementById('rma__order');
      let rmaRma = document.getElementById('rma__rma');

      if (!htmlElementExistsVerify({ rmaOrder, rmaRma })) {
        return;
      };

      rmaOrder.style.display = 'none';
      rmaRma.style.display = 'none';

      fetch(`${RMA_URL}?order=${orderName}&email=${email}&token=${token}&shop=${shop}`)
        .then(response => response.json())
        .then(function (data) {
          const orderDate = Date.parse(data.order.created_at),
            days_placed_order = Math.round((current_date - orderDate) / (24 * 60 * 60 * 1000));

          if (days_placed_order <= expiry_days || expiry_days <= 0) {
            form.style.display = 'none';
            var rmaOrderNumberList = document.querySelectorAll('.rma__orderNumber');
            replaceAllText(rmaOrderNumberList, orderName);

            if (data.order) {
              rmaOrder.style.display = 'block';
              renderOrderTable(data.order);
            }

            if (data.rma.length) {
              rmaRma.style.display = 'block';
              renderRmaTable(data.rma);
            }
          } else {
            var formErrorsList = form.querySelectorAll('rma_form_error__wrapper');
            toggleAll(formErrorsList, 'block');
          }
        })
        .catch((error) => {
          console.warn(error);
          alert(`${window.RMA.strings.alert_order_not_found} ${customerCare}`);
        });
    });

    function renderOrderTable(order) {
      let table = document.getElementById('rma__table');
      let rowTemplate = document.getElementById('rma__row');

      replaceAllText(table, '');
      replaceAllText(rowTemplate, '');

      order.line_items.map(function (item) {
        var row = templateToHtml(rowTemplate, '.rma__row');

        let rmaTitle = row.querySelectorAll('.rma__title');
        replaceAllText(rmaTitle, item.title);

        let rmaTotal = row.querySelectorAll('.rma__total');
        replaceAllText(rmaTotal, item.price);

        let rmaQuantity = row.querySelectorAll('.rma__quantity');
        replaceAllText(rmaQuantity, item.quantity)

        let rmaSKU = row.querySelectorAll('.rma__sku');
        replaceAllText(rmaSKU, item.sku);

        let rmaSKUInput = row.querySelectorAll('[name=sku]');
        setAllNewValue(rmaSKUInput, item.sku);

        let rmaBarcode = row.querySelectorAll('[name=barcode]');
        setAllNewValue(rmaBarcode, item.barcode);

        let rmaID = row.querySelectorAll('[name=id]');
        setAllNewValue(rmaID, item.id);

        //populate reason select
        Object.keys(reasons).map(function (reason) {
          var rmaReasonsSelect = row.querySelectorAll('.rma__reason select');
          var newOption = document.createElement('option');
          var currentReasonLabel = reasons[reason];
          var newReason = document.createTextNode(currentReasonLabel);
          newOption.value = reason;
          newOption.appendChild(newReason);
          appendAllEl(rmaReasonsSelect, newOption);
        });

        //populate quantity select
        //TODO: cross-check with existing RMA
        for (var i = 0; i <= item.max_returnable_quantity; i++) {
          var rmaQtySelect = row.querySelectorAll('.rma__returnQuantity select');
          var newOption = document.createElement('option');
          var currentQtyLabel = i.toString();
          var newQty = document.createTextNode(currentQtyLabel);
          newOption.value = i.toString();
          newOption.appendChild(newQty);
          appendAllEl(rmaQtySelect, newOption);
        }

        if (item.max_returnable_quantity < 1) {
          var selectsList = row.querySelectorAll('.select');
          setAttributeAll(selectsList, 'disabled', 'disabled');
        }

        if (item.image) {
          var imagesList = row.querySelectorAll('.rma__image');
          var newImage = document.createElement('img');
          newImage.setAttribute('src', item.image);
          appendAllEl(imagesList, newImage);
        };

        table.append(row);
      });

      const onRmaSubmit = function () {
        let rma = {
          rows: [],
          order_name: order.name,
          order_id: order.id,
          language: order.customer_locale.split('-')[0]
        };

        let rma__table = document.getElementById('rma__table');
        let rma__row = Array.from(rma__table.getElementsByClassName('rma__row'));

        rma__row.map(function (row) {
          let payload = {
            sku: row.querySelector('[name=sku]').value,
            name: row.querySelector('.rma__title').innerText,
            barcode: row.querySelector('[name=barcode]').value,
            line_item_id: row.querySelector('[name=id]').value,
            quantity_requested: row.querySelector('[name=quantity]').value,
            reason: row.querySelector('[name=reason]').value,
            image: row.querySelector('img').getAttribute('src')
          }

          if (payload.quantity_requested > 0) rma.rows.push(payload);
        });

        if (rma.rows.length < 1) return alert(window.RMA.strings.alert_no_selection);

        if(!DEBUG) {
          fetch(`${RMA_URL}?order=${orderName}&email=${email}&token=${token}&shop=${shop}`, {
            method: 'POST',
            body: JSON.stringify(rma),
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(response => response.json())
            .then(function (data) {
              onRmaSuccess();
            })
            .catch(() => {
              alert(`${window.RMA.strings.alert_generic} ${customerCare}.`);
            });
        } else {
          onRmaSuccess();
        }


      }

      let rma_submit = document.getElementById('rma__submit');

      if (!htmlElementExistsVerify({ rma_submit })) {
        return;
      };

      rma_submit.removeEventListener('click', onRmaSubmit);
      rma_submit.addEventListener('click', onRmaSubmit);
    }

    function renderRmaTable(rma) {

      let table = document.getElementById('rmaStatus__table');
      let rowTemplate = document.getElementById('#rmaStatus__row');

      if (htmlElementExistsVerify({ table, rowTemplate })) {
        table.innerHTML = '';
        rowTemplate.innerHTML = '';
      };

      rma.forEach(function (item) {
        var row = templateToHtml(rowTemplate);

        var rmaTitle = row.querySelectorAll('.rma__title');
        replaceAllText(rmaTitle, item.title);

        var rmaTotal = row.querySelectorAll('.rma__total');
        replaceAllText(rmaTotal, item.price);

        var rmaQty = row.querySelectorAll('.rma__quantity');
        replaceAllText(rmaQty, item.quantity);

        var rmaSku = row.querySelectorAll('.rma__sku')
        replaceAllText(rmaSku, item.sku);

        var rmaName = row.querySelectorAll('.rma__name')
        replaceAllText(rmaName, item.rma_name);

        var rmaReason = row.querySelectorAll('.rma__reasonText');
        replaceAllText(rmaReason, item.reason);
        //row.find('.rma__quantityRequested').text(item.quantity_requested || 0);
        var rmaQtyRequested = row.querySelectorAll('.rma__quantityRequested');
        replaceAllText(rmaQtyRequested, (item.quantity_requested || 0));
        //row.find('.rma__quantityReceived').text(item.quantity_received || 0);
        var rmaQtyReceived = row.querySelectorAll('.rma__quantityReceived');
        replaceAllText(rmaQtyReceived, (item.quantity_received || 0));

        if (item.image) {
          var rmaImage = row.querySelectorAll('.rma__image');
          var newImage = document.createElement('image');
          newImage.setAttribute('src', item.image);
          appendAllEl(rmaImage, newImage);
        };

        table.append(row);
      });
    };
  });
}